import { ReactNode } from 'react';

import { Icon, Text } from '@rbilabs/universal-components';
import { Pressable, StyleSheet, View } from 'react-native';

import { primitive, spacing } from 'styles/constants';

import { LoyaltyPartnerTile } from '../../loyalty-partner-tile';

type IWalmartOfferItem = {
  name: string;
  description: string;
  descriptionL2?: string;
  image: ReactNode;
  activateButtonLabel: string;
  onPartnershipActivate?: (() => void) | undefined;
  isLoadingUser: boolean;
  isWalmartUser?: boolean;
  showUnlinkButton: boolean;
  unlinkButtonLabel: string;
  onUnlinkUser: () => void;
  isUnlinkingUser: boolean;
  onhandleClickWalmartOfferItemCard: () => void;
};

export const WalmartOfferItem = ({
  name,
  description,
  descriptionL2,
  image,
  activateButtonLabel,
  onPartnershipActivate,
  onhandleClickWalmartOfferItemCard,
  isLoadingUser,
  isWalmartUser,
  showUnlinkButton,
  unlinkButtonLabel,
  onUnlinkUser,
  isUnlinkingUser,
}: IWalmartOfferItem) => {
  const showCTA = !isLoadingUser && !isWalmartUser;

  return (
    <LoyaltyPartnerTile
      onPress={isWalmartUser ? onhandleClickWalmartOfferItemCard : undefined}
      image={image}
      title={name}
      description={[description, descriptionL2].filter(Boolean)}
      ctaLabel={showCTA ? activateButtonLabel : undefined}
      onCTAPress={showCTA ? onPartnershipActivate : undefined}
      iconRight={isWalmartUser && <Icon variant="next" />}
      footer={
        !isLoadingUser &&
        isWalmartUser &&
        showUnlinkButton && (
          <View style={styles.bottomContainer}>
            <Pressable
              onPress={onUnlinkUser}
              disabled={isUnlinkingUser}
              style={styles.unlinkButton}
            >
              <Text variant="copyOne" bold>
                {unlinkButtonLabel}
              </Text>
            </Pressable>
          </View>
        )
      }
    />
  );
};

const styles = StyleSheet.create({
  bottomContainer: {
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
    padding: spacing.$4,
    width: '100%',
  },
  unlinkButton: {
    width: spacing.$24,
  },
});
